/**
 * Prevent default event and stop it's propagation. Fire callback, if specified.
 * @param callback
 * @returns
 */
export const defaultPrevented =
  (callback?: () => void) =>
  (event: React.SyntheticEvent): void => {
    event.preventDefault()
    event.stopPropagation()
    callback?.()
  }
